import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const ProductSection = ({ title, description, image, override }) => (
  <div className="max-w-screen-lg mx-auto text-center md:pt-8 md:pb-16 pt-4 pb-8">
    <div className="mx-auto max-w-screen-md">
      {title && (
        <h3 className="text-xl  md:text-4xl font-medium text-indigo-100">
          {title}
        </h3>
      )}
      {description && (
        <div className="pt-3 pb-12 text-indigo-200 leading-relaxed text-sm md:text-base">
          {description}
        </div>
      )}
    </div>
    {image && !override && (
      <div className="w-full flex justify-center">
        <img className="rounded-lg shadow-xl" src={image} />
      </div>
    )}
    {override}
  </div>
)

ProductSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  override: PropTypes.node,
}

ProductSection.defaultProps = {
  title: "",
  subtitle: "",
  image: "",
}

export default ProductSection
